// src/features/feature1/feature1API.js
import axios from "axios";

// const API_URL = "http://18.233.85.48:8080/api/";

export const fetchBrands = () => {
  return axios.get( `${process.env.REACT_APP_API_URL}/brands`);
};

export const fetchCategories = () => {
  return axios.get( `${process.env.REACT_APP_API_URL}/product/categories`);
};

export const fetchProducts = (page = 1, itemsPerPage = 20) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/all/products?page=${page}&limit=${itemsPerPage}`
  );
};

export const fetchDiscountDetails = (discountedId) => {
  return axios.get( `${process.env.REACT_APP_API_URL}/discounts/${discountedId}`);
};

export const fetchProductDetails = (productId) => {
  return axios.get( `${process.env.REACT_APP_API_URL}/products/${productId}`);
};

export const fetchTopSellingProducts = () => {
  return axios.get( `${process.env.REACT_APP_API_URL}/products/top/sale`);
};

export const fetchHealthCategories = () => {
  return axios.get( `${process.env.REACT_APP_API_URL}/health/categories`); // Updated endpoint
};

export const fetchOffers = () => {
  const token = localStorage.getItem("token");

  return axios.get( `${process.env.REACT_APP_API_URL}/offers`, {
    headers: {
      Authorization: token, // Ensure 'Bearer' is used
    },
  });
};

export const fetchofferProducts = (
  minDiscount = 50,
  page = 1,
  itemsPerPage = 20
) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/products/minimum/discounted?mindiscount=${minDiscount}&page=${page}&limit=${itemsPerPage}`
  );
};
 


